module.exports = __webpack_public_path__ + "static/media/optima-seguros-icon-noneOption.fd4f823d.svg";